import { Component, Inject } from '@angular/core'
import {
  MAT_DIALOG_DATA,
  MatDialogActions,
  MatDialogClose,
  MatDialogRef,
  MatDialogTitle,
} from '@angular/material/dialog'
import { MatButton } from '@angular/material/button'
import { gameSetupSiteBaseUrlToken } from '../../providers/game-setup-site-base-url.provider'
import { closeLabelToken } from 'shared-components'
import { WindowService } from 'shared-services'
import { GamePlayService } from 'game-play-services'

@Component({
  selector: 'sans-confirm-leave-game-dialog',
  standalone: true,
  imports: [MatDialogTitle, MatButton, MatDialogActions, MatDialogClose],
  templateUrl: './confirm-leave-game-dialog.component.html',
  styleUrl: './confirm-leave-game-dialog.component.scss',
})
export class ConfirmLeaveGameDialogComponent {
  title = $localize`:Title|Confirm leave game dialog title:Are you sure you want to leave the game?`
  confirmLeaveGameLabel = $localize`:Label|Confirm leave game label:Leave game`

  constructor(
    @Inject(closeLabelToken) public closeLabel: string,
    private dialogRef: MatDialogRef<ConfirmLeaveGameDialogComponent>,
    @Inject(MAT_DIALOG_DATA) private gamePlayId: string,
    private windowService: WindowService,
    private gamePlayService: GamePlayService,
    @Inject(gameSetupSiteBaseUrlToken) private gameSetupSiteBaseUrl: string,
  ) {}

  async onConfirmLeaveGame(): Promise<void> {
    await this.gamePlayService.leaveGamePlay(this.gamePlayId)
    this.windowService.replace(this.gameSetupSiteBaseUrl)
    this.dialogRef.close()
  }
}
